import { render, staticRenderFns } from "./xAxis.vue?vue&type=template&id=0ba638f4&"
import script from "./xAxis.vue?vue&type=script&lang=js&"
export * from "./xAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports